(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1004],{

/***/ 70861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FT": function() { return /* binding */ useButtonProps; }
/* harmony export */ });
/* unused harmony export isTrivialHref */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
const _excluded = ["as", "disabled"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
function useButtonProps({
  tagName,
  disabled,
  href,
  target,
  rel,
  role,
  onClick,
  tabIndex = 0,
  type
}) {
  if (!tagName) {
    if (href != null || target != null || rel != null) {
      tagName = 'a';
    } else {
      tagName = 'button';
    }
  }
  const meta = {
    tagName
  };
  if (tagName === 'button') {
    return [{
      type: type || 'button',
      disabled
    }, meta];
  }
  const handleClick = event => {
    if (disabled || tagName === 'a' && isTrivialHref(href)) {
      event.preventDefault();
    }
    if (disabled) {
      event.stopPropagation();
      return;
    }
    onClick == null ? void 0 : onClick(event);
  };
  const handleKeyDown = event => {
    if (event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };
  if (tagName === 'a') {
    // Ensure there's a href so Enter can trigger anchor button.
    href || (href = '#');
    if (disabled) {
      href = undefined;
    }
  }
  return [{
    role: role != null ? role : 'button',
    // explicitly undefined so that it overrides the props disabled in a spread
    // e.g. <Tag {...props} {...hookProps} />
    disabled: undefined,
    tabIndex: disabled ? undefined : tabIndex,
    href,
    target: tagName === 'a' ? target : undefined,
    'aria-disabled': !disabled ? undefined : disabled,
    rel: tagName === 'a' ? rel : undefined,
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, meta];
}
const Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
      as: asProp,
      disabled
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [buttonProps, {
    tagName: Component
  }] = useButtonProps(Object.assign({
    tagName: asProp,
    disabled
  }, props));
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Component, Object.assign({}, props, buttonProps, {
    ref: ref
  }));
});
Button.displayName = 'Button';
/* harmony default export */ __webpack_exports__["ZP"] = (Button);

/***/ }),

/***/ 67636:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tiles",
      function () {
        return __webpack_require__(21342);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ tiles; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./pages/tiles/category.json
var category_namespaceObject = {};
// EXTERNAL MODULE: ./node_modules/react-loaders-kit/lib/index.js
var lib = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/react-typed/dist/react-typed.js
var react_typed = __webpack_require__(27788);
var react_typed_default = /*#__PURE__*/__webpack_require__.n(react_typed);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 6 modules
var Modal = __webpack_require__(6212);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./config.js
var config = __webpack_require__(83346);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./api.services.js/catalouge.js + 1 modules
var catalouge = __webpack_require__(27719);
// EXTERNAL MODULE: ./node_modules/sweetalert/dist/sweetalert.min.js
var sweetalert_min = __webpack_require__(46737);
var sweetalert_min_default = /*#__PURE__*/__webpack_require__.n(sweetalert_min);
// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(19755);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);
// EXTERNAL MODULE: ./api.services.js/others.js + 2 modules
var others = __webpack_require__(63372);
// EXTERNAL MODULE: ./src/components/loader.js
var loader = __webpack_require__(62077);
// EXTERNAL MODULE: ./src/productCard.js
var productCard = __webpack_require__(93115);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 10 modules
var Form = __webpack_require__(4492);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./src/UnbxdProductCard.js
var UnbxdProductCard = __webpack_require__(64642);
// EXTERNAL MODULE: ./attributes.json
var attributes = __webpack_require__(25690);
;// CONCATENATED MODULE: ./pages/tiles/index.js





//import Modal from "react-modal";

















const Category = (data)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    let router = (0,next_router.useRouter)();
    const [ProdBySalesDate, setProdBySalesDate] = (0,react.useState)(data.ProdBySalesDate);
    const [PageSalesSize, setPageSalesSize] = (0,react.useState)(25);
    const [fitterrss2, setfitterrss2] = (0,react.useState)(data.fitterrss2);
    const [dataSet, setDataSet] = (0,react.useState)(data.data.products);
    const [filterData, setFilterData] = (0,react.useState)(data.data.products.aggregations);
    const [selectedFilterData, setSelectedFilterData] = (0,react.useState)();
    const [filterTypeDataSet, setFilterTypeDataSet] = (0,react.useState)();
    const [isParamChange, setIsParamChange] = (0,react.useState)(false);
    const [relatedBlogData, setRelatedBlogData] = (0,react.useState)([]);
    const [sortValue, setSortValue] = (0,react.useState)(data.data.products.sort_fields.default);
    const [selectedCode, setSelectedCode] = (0,react.useState)("");
    const [selectedFilters, setSelectedFilters] = (0,react.useState)([]);
    const [isFilterselected, setIsFilterselected] = (0,react.useState)(false);
    const [openFilterFlag, setOpenFilterFlag] = (0,react.useState)(false);
    const [isAmbience, setIsAmbience] = (0,react.useState)(false);
    const [loading, setLoading] = (0,react.useState)(false);
    const [loading2, setLoading2] = (0,react.useState)(false);
    const [shortDiscription, setShortDiscription] = (0,react.useState)((ref = data.data.products.currentcategory) === null || ref === void 0 ? void 0 : ref.description);
    const [getInTouch, setGetInTouch] = (0,react.useState)(false);
    const [filteractive, setFilterActive] = (0,react.useState)("");
    const [mobileFilterOpen, setmobileFilterOpen] = (0,react.useState)(false);
    const [touch, setTouch] = (0,react.useState)({
        name: "",
        number: "",
        pincode: js_cookie/* default.get */.Z.get("pincode"),
        error: "",
        loading: false
    });
    const [pageLayoutClass, setPageLayoutlass] = (0,react.useState)("product-listing-Three obl-pro-list-row");
    const [filterSet, setFilterSet] = (0,react.useState)({
        filter: {
            category_id: {
                in: [
                    data.value
                ]
            }
        },
        sort: {
            recommended: "ASC"
        },
        pageSize: 25,
        currentPage: 1
    });
    const [modalIsOpen, setModalIsOpen] = (0,react.useState)(false);
    const [pincode, setPinCode] = (0,react.useState)(undefined);
    const [UnbxdPdts, setUnbxdPdts] = (0,react.useState)(data.UnbxdResponse.products);
    const [totalPdtsFromUnbxd, setTotalPdtsFromUnbxd] = (0,react.useState)(data.UnbxdResponse.numberOfProducts);
    let pageSizeUnbxd = data === null || data === void 0 ? void 0 : (ref1 = data.UnbxdResponse) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.length;
    const [defaultFacets, setDefaultFacets] = (0,react.useState)(data === null || data === void 0 ? void 0 : (ref3 = data.facetsUnbxd) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.text) === null || ref4 === void 0 ? void 0 : ref4.list);
    const [selectedFilterFromUnbxd, setSelectedFilterFromUnbxd] = (0,react.useState)([]);
    const [noOfFilteredPdtFromUnbxd, setNoOfFilteredPdtFromUnbxd] = (0,react.useState)("");
    const totalProducts = (0,react.useMemo)(()=>{
        return selectedFilterFromUnbxd.length > 1 ? noOfFilteredPdtFromUnbxd : data.UnbxdResponse.numberOfProducts;
    }, [
        selectedFilterFromUnbxd,
        noOfFilteredPdtFromUnbxd,
        data.UnbxdResponse.numberOfProducts
    ]);
    const filterMapArr = [
        {
            tileType_uFilter: "tile_type",
            tileSize_uFilter: "tile_size",
            tilesFinish_uFilter: "tiles_finish",
            colors_uFilter: "colors",
            tileCollections_uFilter: "tile_collections",
            tileFactoryProduction_uFilter: "tile_factory_production",
            tileDesign_uFilter: "tile_design",
            tileCategory_uFilter: "tile_category",
            tileArea_uFilter: "tile_area"
        }
    ];
    const [showClearAll, setShowClearAll] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        var ref;
        window.UnbxdAnalyticsConf = window.UnbxdAnalyticsConf || {};
        window.UnbxdAnalyticsConf["page"] = router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("?")[0];
        window.UnbxdAnalyticsConf["page_type"] = "BOOLEAN";
        setLoading(false);
        setLoading(false);
        setDataSet(data.data.products);
        setProdBySalesDate(data.ProdBySalesDate);
        setfitterrss2(data.fitterrss2);
        setFilterData(data.data.products.aggregations);
    // if(data.data.products.currentcategory?.description){
    //   appendBaseUrlToSrc(data.data.products.currentcategory.description)
    // }
    }, [
        router
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if ((ref = data.data.products.currentcategory) === null || ref === void 0 ? void 0 : ref.description) {
            appendBaseUrlToSrc(data.data.products.currentcategory.description);
        }
        jquery_default()(".toggle").click(function(e) {
            e.preventDefault();
            var $this = jquery_default()(this);
            if ($this.next().hasClass("show")) {
                $this.next().removeClass("show");
                $this.next().slideUp(350);
            } else {
                $this.parent().parent().find("li .inner").removeClass("show");
                $this.parent().parent().find("li .inner").slideUp(350);
                $this.next().toggleClass("show");
            }
        });
        var requestOptions = {
            method: "GET"
        };
        const tempFilterTypeArray = [];
        filterData.forEach((obj)=>{
            if (obj.attribute_code == "tile_category") {
                tempFilterTypeArray.push("Floor");
            } else if (obj.attribute_code !== "price" && obj.attribute_code !== "istiles" && obj.attribute_code !== "plocation" && obj.attribute_code !== "category_id" && obj.attribute_code !== "recommended" && obj.attribute_code !== "popularity" && obj.attribute_code !== "available_region_bucket") {
                tempFilterTypeArray.push(obj.label);
            }
        });
        setFilterTypeDataSet(tempFilterTypeArray);
        onFilterOnClickButton(tempFilterTypeArray[0]);
        const selectedFilterFromLocalStorage = localStorage.getItem("selectedFilter");
        const pin = js_cookie/* default.get */.Z.get("pincode");
        setPinCode(pin);
        fetch("".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/blog/wp-json/post/v2/category/term=").concat(data.categoryValue), requestOptions).then((response)=>response.text()).then((result)=>{
            setRelatedBlogData(JSON.parse(result));
        }).catch((error)=>console.log("error", error));
        if (selectedFilterFromLocalStorage) {
        // const finalResult = JSON.parse(selectedFilterFromLocalStorage);
        // const selFilt = {
        //   key: finalResult.key,
        //   value: finalResult.value,
        //   code: finalResult.code,
        // };
        // selectedFilters.push(selFilt);
        // setSelectedFilters(selectedFilters);
        // setIsFilterselected(true);
        // setPinCode(pin);
        } else {
            // setPinCode(undefined);
            setTimeout(()=>{
            // if(!localStorage.getItem('pincodeSkip')){
            //   setModalIsOpen(true);
            // }
            }, 5000);
        }
    }, [
        router
    ]);
    let loadMoreSalesData = async ()=>{
        setLoading2(true);
        let respp = await axios/* default.post */.Z.post("https://proxy.orientbell.com/api/products?category=".concat(data.value, "&pincode=").concat(js_cookie/* default.get */.Z.get("pincode"), "&size=").concat(PageSalesSize + 25), fitterrss2);
        setPageSalesSize(PageSalesSize + 25);
        setProdBySalesDate(respp.data);
        setLoading2(false);
    };
    const loadMoreSalesData2 = async ()=>{
        setLoading2(true);
        try {
            var ref;
            const pageSize = 25;
            const currentCount = UnbxdPdts.length;
            // Start building the URL
            const unbxdUrl = new URL("https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category");
            unbxdUrl.searchParams.append("p-id", 'categoryPathId:"'.concat(decodeURIComponent((ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("?")[0]), '"'));
            unbxdUrl.searchParams.append("facet.multiselect", "true");
            unbxdUrl.searchParams.append("spellcheck", "true");
            unbxdUrl.searchParams.append("pagetype", "boolean");
            unbxdUrl.searchParams.append("start", "".concat(currentCount));
            unbxdUrl.searchParams.append("rows", "".concat(pageSize));
            unbxdUrl.searchParams.append("version", "V2");
            unbxdUrl.searchParams.append("fallback", "true");
            unbxdUrl.searchParams.append("viewType", "GRID");
            unbxdUrl.searchParams.append("facet.version", "V2");
            // ✅ Append selected filters from state
            selectedFilterFromUnbxd.forEach((param)=>{
                let { facetName , facetValue  } = param;
                unbxdUrl.searchParams.append("filter", "".concat(facetName, ':"').concat(facetValue, '"'));
            });
            const response = await axios/* default.get */.Z.get(unbxdUrl.toString(), {
                headers: {
                    "unbxd-user-id": js_cookie/* default.get */.Z.get("unbxd.userId")
                }
            });
            const newProducts = response.data.response.products || [];
            if (newProducts.length > 0) {
                setUnbxdPdts((prevPdts)=>[
                        ...prevPdts,
                        ...newProducts
                    ]);
            }
            setTotalPdtsFromUnbxd(response.data.response.numberOfProducts);
        } catch (error) {
            console.error("Error loading more products:", error);
        }
        setLoading2(false);
    };
    (0,react.useEffect)(()=>{
        if (isParamChange) {
            jquery_default()(".main-sidebar").removeClass("open-filter");
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            let filterrrr = filterSet.filter;
            if (data.regionData) {
                filterrrr = {
                    ...filterrrr,
                    plocation: {
                        in: [
                            data.regionData.value
                        ]
                    }
                };
            }
            var graphql = JSON.stringify({
                variables: {
                    filter: data.fitterrss,
                    sort: filterSet.sort,
                    pageSize: filterSet.pageSize,
                    currentPage: filterSet.currentPage
                },
                query: getProductQuery
            });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: graphql,
                redirect: "follow"
            };
            fetch("https://proxy.orientbell.com", requestOptions).then((response)=>response.text()).then((result)=>{
                const finalResult = JSON.parse(result);
                setDataSet(finalResult.data.products);
                appendBaseUrlToSrc(finalResult.data.products.currentcategory.description);
                setFilterData(finalResult.data.products.aggregations);
                const tempFilterTypeArray = [];
                finalResult.data.products.aggregations.forEach((obj)=>{
                    if (obj.attribute_code == "tile_category") {
                        tempFilterTypeArray.push("Floor");
                    } else if (obj.attribute_code !== "price" && obj.attribute_code !== "istiles" && obj.attribute_code !== "plocation" && obj.attribute_code !== "category_id" && obj.attribute_code !== "recommended" && obj.attribute_code !== "popularity" && obj.attribute_code !== "available_region_bucket") {
                        tempFilterTypeArray.push(obj.label);
                    }
                });
                setFilterTypeDataSet(tempFilterTypeArray);
                setOpenFilterFlag(true);
                setIsParamChange(false);
                setLoading(false);
                setLoading2(false);
            }).catch((error)=>console.log("error", error));
        }
    }, [
        filterSet,
        isParamChange,
        data.appliedFilterFromUnbxd
    ]);
    (0,react.useEffect)(()=>{
        if (isFilterselected) {
            let createFilterDtoSet = {
                category_id: {
                    in: [
                        data.value
                    ]
                }
            };
            selectedFilters.forEach((obj)=>{
                if (obj.code in createFilterDtoSet) {
                    const arrayValue = createFilterDtoSet[obj.code].in;
                    if (!arrayValue.includes(obj.key)) {
                        arrayValue.push(obj.key);
                    }
                    createFilterDtoSet[obj.code].in = arrayValue;
                } else {
                    const newFilterSet = {
                        [obj.code]: {
                            in: [
                                obj.key
                            ]
                        }
                    };
                    createFilterDtoSet = {
                        ...createFilterDtoSet,
                        ...newFilterSet
                    };
                }
            });
            setFilterSet({
                ...filterSet,
                filter: createFilterDtoSet
            });
            setLoading(true);
            setIsParamChange(true);
            setIsFilterselected(false);
        }
    }, [
        selectedFilters,
        isFilterselected
    ]);
    (0,react.useEffect)(()=>{
        if (openFilterFlag) {
            onFilterOnClickButton(filterTypeDataSet[0]);
            setOpenFilterFlag(false);
        }
    }, [
        filterData
    ]);
    const getProductQuery = "query Products ($filter: ProductAttributeFilterInput!, $sort: ProductAttributeSortInput!, $pageSize: Int!, $currentPage: Int!){\n      products(\n          filter: $filter,\n          sort: $sort,\n          pageSize: $pageSize,\n          currentPage: $currentPage\n      ) {\n      currentcategory{\n          name\n          description\n          dynamic_content\n          imageUrl\n          meta_keywords\n          meta_description\n          meta_title\n          schema\n          breadcrumbs{\n            category_id\n            category_name\n            category_level\n            category_url_key\n            category_url_path\n        }\n      }\n      appliedFilters{\n        label\n        value\n        attribute_code\n    }\n      aggregations(filter: { category: {includeDirectChildrenOnly: true}}) {\n          attribute_code\n          count\n          label\n          options {\n              label\n              value\n              count\n              swatch_data {\n                  type\n                  value\n              }\n          }\n      }\n      subcategories{\n          id\n          name\n          imageUrl\n      }\n      total_count\n      items {\n          id\n          name\n          sku\n          url_key\n          price_range {\n          minimum_price {\n              regular_price {\n              value\n              currency\n              }\n              final_price {\n              value\n              currency\n              }\n              discount {\n              amount_off\n              percent_off\n              }\n          }\n          maximum_price {\n              regular_price {\n              value\n              currency\n              }\n              final_price {\n              value\n              currency\n              }\n              discount {\n              amount_off\n              percent_off\n              }\n          }\n          }\n          extraVariables{\n            skd_stock\n				     dora_stock\n				     hoskote_stock\n				     west_zone_stock\n              is_enabled\n              is_new\n              image_url\n              ambience_image_url\n              product_url\n              tile_size\n              sq_ft_price\n          }\n      }\n      total_count\n      sort_fields{\n          default\n          options {\n          value\n          label\n          }\n      }\n      }\n    }";
    const getPloaction = "query P_location($pincode: Int!){\n    p_location(pincode : $pincode){\n      pincode\n      attribute_name\n      state\n      value\n    }\n  }";
    const onFilterOnClickButton = (value)=>{
        const filterValuesArray = [];
        if (value == "Floor") {
            filterData.forEach((obj)=>{
                if (obj.label == "Tile Category") {
                    setSelectedCode(obj.attribute_code);
                    obj.options.forEach((val)=>{
                        const tempFilterDataSet = {
                            key: val.value,
                            value: val.label
                        };
                        if (tempFilterDataSet.key != tempFilterDataSet.value) {
                            filterValuesArray.push(tempFilterDataSet);
                        }
                    });
                }
            });
        } else {
            filterData.forEach((obj)=>{
                if (obj.label == value) {
                    setSelectedCode(obj.attribute_code);
                    obj.options.forEach((val)=>{
                        const tempFilterDataSet = {
                            key: val.value,
                            value: val.label
                        };
                        if (tempFilterDataSet.key != tempFilterDataSet.value) {
                            filterValuesArray.push(tempFilterDataSet);
                        }
                    });
                }
            });
        }
        setSelectedFilterData(filterValuesArray);
    };
    const handleSortChange = (e)=>{
        var ref, ref1;
        setSortValue((ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
        const newSort = {
            [(ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.value]: "ASC"
        };
        setFilterSet({
            ...filterSet,
            sort: newSort
        });
        setLoading(true);
        setIsParamChange(true);
    };
    const onFilterClick = (e, title)=>{
        setmobileFilterOpen(false);
        setLoading(true);
        let queryObj = router.query;
        queryObj[selectedCode] = e;
        delete queryObj["category"];
        router.replace({
            pathname: "/tiles",
            query: queryObj
        });
        return;
        const selFilt = {
            key: e,
            value: title,
            code: selectedCode
        };
        selectedFilters.push(selFilt);
        setSelectedFilters(selectedFilters);
        setIsFilterselected(true);
    };
    const handleRemove = (input)=>{
        setLoading(true);
        let queryObj = router.query;
        if (queryObj[input.attribute_code].split(",").length == 1) {
            delete queryObj[input.attribute_code];
        } else {
            queryObj[input.attribute_code] = queryObj[input.attribute_code].split(",").filter((cc)=>cc != input.value).join(",");
        }
        delete queryObj["category"];
        router.replace({
            pathname: "/tiles",
            query: queryObj
        });
        return;
        let toRemoveFilter = selectedFilters;
        toRemoveFilter = toRemoveFilter.filter((item)=>item !== input);
        setSelectedFilters(toRemoveFilter);
        setIsFilterselected(true);
        if (input.code == "plocation") {
            localStorage.removeItem("selectedFilter");
            setPinCode("");
        }
    };
    const handleClick = ()=>{
        const cleanUrl = window.location.pathname; // Get only the path without query params
        router.replace(cleanUrl, undefined, {
            shallow: true
        }); // Update URL without reloading
        setTimeout(()=>{
            handleRemove2();
        }, 100); // Slight delay to ensure URL updates before reloading the page
    };
    const handleRemove2 = ()=>{
        setLoading(true);
        js_cookie/* default.remove */.Z.remove("pincode");
        localStorage.removeItem("pincode");
        js_cookie/* default.set */.Z.set("removelocation", true, {
            expires: 7
        });
        router.reload();
    };
    const removeAllFilters = ()=>{
        handleRemove2();
        router.replace({
            pathname: "/tiles"
        });
        return;
        setFilterSet({
            ...filterSet,
            filter: {
                category_id: {
                    in: [
                        data.value
                    ]
                }
            }
        });
        setLoading(true);
        setIsParamChange(true);
        setSelectedFilters([]);
        localStorage.removeItem("selectedFilter");
        setPinCode("");
    };
    const handleAmbience = (e)=>{
        setIsAmbience(e.target.checked);
    };
    const LoadFunction = ()=>{
        const loaderProps = {
            loading: true,
            size: 275,
            duration: 2,
            colors: [
                "#99fffe",
                "#f42e00",
                "#042549"
            ]
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "loader",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.GooeyCircleLoader, {
                    ...loaderProps
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((react_typed_default()), {
                    className: "loader-text",
                    strings: [
                        "Loading..."
                    ],
                    typeSpeed: 60,
                    backSpeed: 0
                })
            ]
        });
    };
    const handleLayOutclass = (type)=>{
        if (type == "one") {
            setPageLayoutlass("product-listing-Three obl-pro-list-row");
        } else if (type == "two") {
            setPageLayoutlass("product-listing-Two obl-pro-list-row");
        } else if (type == "three") {
            setPageLayoutlass("product-listing-One obl-pro-list-row");
        }
    };
    const handlePinCodeChange = (e)=>{
        setPinCode(e.target.value);
    };
    const handlePinCodeChangeInput = (e)=>{
        setPinCode(e.target.value);
        const pincode = e.target.value * 1;
        if (e.target.value.length == 6) {
            var ref;
            setLoading(true);
            (0,others/* savePincode */.y1)({
                pincodedetails: pincode
            });
            js_cookie/* default.set */.Z.set("pincode", pincode, {
                expires: 7
            });
            localStorage.setItem("pincode", pincode);
            localStorage.setItem("pincodeSkip", true);
            if ((ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : (ref = ProdBySalesDate.data) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                setShowClearAll("node");
            } else {
                setShowClearAll("unbxd");
            }
            router.reload();
            return;
            setLoading(true);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var graphql = JSON.stringify({
                query: getPloaction,
                variables: {
                    pincode
                }
            });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: graphql,
                redirect: "follow"
            };
            fetch("https://proxy.orientbell.com", requestOptions).then((response)=>response.text()).then((result)=>{
                let filterArray = selectedFilters;
                if (selectedFilters.length > 0) {
                    localStorage.removeItem("selectedFilter");
                    localStorage.removeItem("pincode");
                    filterArray = filterArray.filter((item)=>item.code !== "plocation");
                }
                const finalResult = JSON.parse(result);
                const selFilt = {
                    key: finalResult.data.p_location.value,
                    value: finalResult.data.p_location.state,
                    code: finalResult.data.p_location.attribute_name
                };
                filterArray.push(selFilt);
                setSelectedFilters(filterArray);
                setIsFilterselected(true);
                setModalIsOpen(false);
                localStorage.setItem("selectedFilter", JSON.stringify(selFilt));
                localStorage.setItem("pincode", pincode);
                js_cookie/* default.set */.Z.set("pincode", pincode, {
                    expires: 7
                });
            }).catch((error)=>console.log("error", error));
        }
    };
    const handlePinSave = ()=>{
        if (pincode.length == 6) {
            setModalIsOpen(false);
            localStorage.setItem("pincodeSkip", true);
            setLoading(true);
            (0,others/* savePincode */.y1)({
                pincodedetails: pincode
            });
            js_cookie/* default.set */.Z.set("pincode", pincode, {
                expires: 7
            });
            localStorage.setItem("pincode", pincode);
            router.reload();
            return;
            setLoading(true);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var graphql = JSON.stringify({
                query: getPloaction,
                variables: {
                    pincode
                }
            });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: graphql,
                redirect: "follow"
            };
            fetch("https://proxy.orientbell.com", requestOptions).then((response)=>response.text()).then((result)=>{
                const finalResult = JSON.parse(result);
                const selFilt = {
                    key: finalResult.data.p_location.value,
                    value: finalResult.data.p_location.state,
                    code: finalResult.data.p_location.attribute_name
                };
                selectedFilters.push(selFilt);
                setSelectedFilters(selectedFilters);
                setIsFilterselected(true);
                setModalIsOpen(false);
                localStorage.setItem("selectedFilter", JSON.stringify(selFilt));
                localStorage.setItem("pincode", pincode);
            }).catch((error)=>console.log("error", error));
        } else {
            alert("Invalid Pin Code");
        }
    };
    const addProductToComapre = async (id)=>{
        if (localStorage.getItem("compareListUid")) {
            let addProduct = await (0,catalouge/* addItemInCompareList */.AQ)({
                compareListUid: localStorage.getItem("compareListUid"),
                productIds: [
                    String(id)
                ]
            });
            if (addProduct === null || addProduct === void 0 ? void 0 : addProduct.message) {
                sweetalert_min_default()(addProduct.message);
                return;
            }
            sweetalert_min_default()({
                title: "Item added",
                text: "You have ".concat(addProduct.data.addProductsToCompareList.item_count, " in your compare list"),
                icon: "success",
                buttons: [
                    "Cancel",
                    "Compare"
                ]
            }).then((result)=>{
                if (result) {
                    router.push("/catalog/product_compare");
                }
            });
        } else {
            let createList = await (0,catalouge/* createCompareList */.j9)({
                productIds: [
                    String(id)
                ]
            });
            if (createList.message) {
                sweetalert_min_default()(createList.message);
            } else {
                localStorage.setItem("compareListUid", createList.data.createCompareList.uid);
                sweetalert_min_default()("Iteam added in you compare list and more items to compare");
            }
        }
    };
    const appendBaseUrlToSrc = (htmlContent)=>{
        const tempElement = document.createElement("div");
        tempElement.innerHTML = htmlContent.replace(/<p>\s*<\/p>/g, "");
        const imgElements = tempElement.querySelectorAll("img");
        imgElements.forEach((img)=>{
            const src = img.getAttribute("src");
            if (src && (!src.startsWith("http") || !src.startsWith("https"))) {
                img.setAttribute("src", config/* default.API_ENDPOINT */.Z.API_ENDPOINT + "/" + src);
            } else {
                img.setAttribute("src", "/" + src);
            }
        });
        setShortDiscription(tempElement.innerHTML);
    };
    const submitGetInTouch = async ()=>{
        const namee = touch.name;
        const no = touch.number;
        const pin = touch.pincode;
        if (!namee || !no || !pin) {
            setTouch({
                ...touch,
                error: "All fields are required"
            });
        } else if (String(pin).length != 6) {
            setTouch({
                ...touch,
                error: "Invalid Pincode"
            });
        } else {
            setTouch({
                ...touch,
                error: "",
                loading: true
            });
            let response = await (0,others/* getIntouch */.JJ)({
                name: namee,
                phone: no,
                pincode: pin
            });
            if (response === null || response === void 0 ? void 0 : response.message) {
                localStorage.setItem("leadfilled", true);
                sweetalert_min_default()(response === null || response === void 0 ? void 0 : response.message);
                setTouch({
                    ...touch,
                    error: "",
                    loading: false
                });
            } else {
                sweetalert_min_default()(response.data.get_in_touch.msg);
                setGetInTouch(false);
                setTouch({
                    name: "",
                    number: "",
                    error: "",
                    loading: false
                });
            }
        }
    };
    const breadsCrumbSchema = ()=>{
        return {
            __html: '{\n        "@context": "https://schema.org/", \n        "@type": "BreadcrumbList", \n        "itemListElement": [{\n          "@type": "ListItem", \n          "position": 1, \n          "name": "Home",\n          "item": "https://www.orientbell.com"\n        },{\n          "@type": "ListItem", \n          "position": 2, \n          "name": "Tiles",\n          "item": "https://www.orientbell.com/tiles"  \n        },{\n         "@type": "ListItem", \n         "position": 3, \n         "name": "'.concat(dataSet.currentcategory.name, '",\n         "item": "').concat(router.asPath, '"  \n       }\n      ]\n      }')
        };
    };
    const webPageSchema = ()=>{
        var ref, ref1, ref2, ref3, ref4;
        return {
            __html: '{\n        "@context": "https://schema.org",\n        "@type": "WebPage",\n        "url": "'.concat(router.asPath, '",\n        "headline": "",\n        "breadcrumb": "Home > Tiles > ').concat(((ref = dataSet.currentcategory) === null || ref === void 0 ? void 0 : ref.breadcrumbs) ? (ref2 = (ref1 = dataSet.currentcategory) === null || ref1 === void 0 ? void 0 : ref1.breadcrumbs[1]) === null || ref2 === void 0 ? void 0 : ref2.category_name : "", '",\n        "name": "').concat(dataSet === null || dataSet === void 0 ? void 0 : (ref3 = dataSet.currentcategory) === null || ref3 === void 0 ? void 0 : ref3.meta_title, '",\n        "description": "').concat(dataSet === null || dataSet === void 0 ? void 0 : (ref4 = dataSet.currentcategory) === null || ref4 === void 0 ? void 0 : ref4.meta_description, '"\n      }')
        };
    };
    const handleRemoveUnbxdFilter = (filterToRemove)=>{
        setSelectedFilterFromUnbxd((prevFilters)=>{
            // Remove the selected filter from state
            const updatedFilters = prevFilters.filter((filter)=>!(filter.facetName === filterToRemove.facetName && filter.facetValue === filterToRemove.facetValue));
            // Update URL query params after removing the filter
            const urlObj = new URL(window.location.href);
            // Get the transformed filter name and value
            const { transformedName , transformedValue  } = transformFilter(filterToRemove.facetName, filterToRemove.facetValue);
            // Remove only the matching query parameter from URL
            urlObj.searchParams.delete(transformedName);
            // Update browser history without reloading
            window.history.pushState({}, "", urlObj.toString());
            // Construct the new Unbxd API URL
            const unbxdUrl = new URL("https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category?p-id=categoryPathId%3A%22".concat(encodeURIComponent(router.asPath.split("?")[0]), "%22"));
            // Add fixed parameters
            unbxdUrl.searchParams.append("facet.multiselect", "true");
            unbxdUrl.searchParams.append("spellcheck", "true");
            unbxdUrl.searchParams.append("pagetype", "boolean");
            unbxdUrl.searchParams.append("start", "0");
            unbxdUrl.searchParams.append("rows", "".concat(pageSizeUnbxd + 25));
            unbxdUrl.searchParams.append("version", "V2");
            unbxdUrl.searchParams.append("fallback", "true");
            unbxdUrl.searchParams.append("viewType", "GRID");
            unbxdUrl.searchParams.append("facet.version", "V2");
            // Apply remaining filters to API request
            updatedFilters.forEach((param)=>{
                let { facetName , facetValue  } = param;
                unbxdUrl.searchParams.append("filter", "".concat(facetName, ':"').concat(facetValue, '"'));
            });
            // Make the API call
            (async ()=>{
                try {
                    const response = await axios/* default.get */.Z.get(unbxdUrl.toString(), {
                        headers: {
                            "unbxd-user-id": js_cookie/* default.get */.Z.get("unbxd.userId")
                        }
                    });
                    // Update state with the response
                    setUnbxdPdts(response.data.response.products);
                    setNoOfFilteredPdtFromUnbxd(response.data.response.numberOfProducts);
                } catch (error) {
                    console.log(error);
                    sweetalert_min_default()("Something went wrong while removing the filter, please try again.");
                }
            })();
            return updatedFilters;
        });
    };
    const removeUnbxdFilters = async ()=>{
        // Clear all filters from state
        setSelectedFilterFromUnbxd([]);
        // Remove all filters from URL
        const urlObj = new URL(window.location.href);
        urlObj.search = ""; // Clears query params
        window.history.pushState({}, "", urlObj.toString());
        // Construct API URL without filters
        const unbxdUrl = new URL("https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category?p-id=categoryPathId%3A%22".concat(encodeURIComponent(router.asPath.split("?")[0]), "%22"));
        // Add fixed parameters
        unbxdUrl.searchParams.append("facet.multiselect", "true");
        unbxdUrl.searchParams.append("spellcheck", "true");
        unbxdUrl.searchParams.append("pagetype", "boolean");
        unbxdUrl.searchParams.append("start", "0");
        unbxdUrl.searchParams.append("rows", "25");
        unbxdUrl.searchParams.append("version", "V2");
        unbxdUrl.searchParams.append("fallback", "true");
        unbxdUrl.searchParams.append("viewType", "GRID");
        unbxdUrl.searchParams.append("facet.version", "V2");
        try {
            const response = await axios/* default.get */.Z.get(unbxdUrl.toString(), {
                headers: {
                    "unbxd-user-id": js_cookie/* default.get */.Z.get("unbxd.userId")
                }
            });
            // Update state with unfiltered results
            setUnbxdPdts(response.data.response.products);
            setNoOfFilteredPdtFromUnbxd(response.data.response.numberOfProducts);
        } catch (error) {
            console.log(error);
            sweetalert_min_default()("Something went wrong while removing filters, please try again.");
        }
    };
    const transformFilter = (facetName, facetValue)=>{
        var ref;
        // Get the transformed filter name
        const filterMapping = filterMapArr[0]; // Extracting from the array
        const transformedName = filterMapping[facetName] || facetName; // Default to original if no mapping
        // Get the transformed value
        const valueMapping = ((ref = attributes[transformedName]) === null || ref === void 0 ? void 0 : ref.options) || {}; // Fetch value mapping from JSON
        const transformedValue = Object.keys(valueMapping).find((key)=>valueMapping[key] === facetValue) || facetValue; // Default to original if no match
        return {
            transformedName,
            transformedValue
        };
    };
    const filterResultsWithFacets = async (facetName, facetValue)=>{
        setSelectedFilterFromUnbxd((prevFilters)=>{
            const existingFilter = prevFilters.filter((filter)=>filter.facetName === facetName);
            let updatedFilters;
            if (existingFilter.length > 0) {
                updatedFilters = [
                    ...prevFilters.filter((filter)=>filter.facetName !== facetName),
                    {
                        facetName,
                        facetValue
                    }
                ];
            } else {
                updatedFilters = [
                    ...prevFilters,
                    {
                        facetName,
                        facetValue
                    }
                ];
            }
            setmobileFilterOpen(false);
            // Update URL query params
            const urlObj = new URL(window.location.href);
            updatedFilters.forEach((param)=>{
                let { facetName , facetValue  } = param;
                const { transformedName , transformedValue  } = transformFilter(facetName, facetValue);
                urlObj.searchParams.set(transformedName, transformedValue);
            });
            // Push updated URL without reloading
            window.history.pushState({}, "", urlObj.toString());
            console.log(router.asPath);
            // Unbxd API URL setup
            const unbxdUrl = new URL("https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category?p-id=categoryPathId%3A%22".concat(encodeURIComponent(router.asPath.split("?")[0]), "%22"));
            // Add query parameters
            unbxdUrl.searchParams.append("facet.multiselect", "true");
            unbxdUrl.searchParams.append("spellcheck", "true");
            unbxdUrl.searchParams.append("pagetype", "boolean");
            unbxdUrl.searchParams.append("start", "0");
            unbxdUrl.searchParams.append("rows", "".concat(pageSizeUnbxd + 25));
            unbxdUrl.searchParams.append("version", "V2");
            unbxdUrl.searchParams.append("fallback", "true");
            unbxdUrl.searchParams.append("viewType", "GRID");
            unbxdUrl.searchParams.append("facet.version", "V2");
            // Apply transformed filters to API request
            updatedFilters.forEach((param)=>{
                let { facetName , facetValue  } = param;
                const { transformedName , transformedValue  } = transformFilter(facetName, facetValue);
                unbxdUrl.searchParams.append("filter", "".concat(facetName, ':"').concat(facetValue, '"'));
            });
            // Make the API call
            (async ()=>{
                try {
                    const response = await axios/* default.get */.Z.get(unbxdUrl.toString(), {
                        headers: {
                            "unbxd-user-id": js_cookie/* default.get */.Z.get("unbxd.userId")
                        }
                    });
                    // Update state with the response
                    setUnbxdPdts(response.data.response.products);
                    setNoOfFilteredPdtFromUnbxd(response.data.response.numberOfProducts);
                    setPageSalesSize(response.data.response.products.length);
                } catch (error) {
                    console.log(error);
                    sweetalert_min_default()("Something went wrong, please try again later.");
                }
            })();
            return updatedFilters;
        });
    };
    (0,react.useEffect)(()=>{
        var ref;
        if (((ref = data.appliedFilterFromUnbxd) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            const validFilters = [];
            const validQueryParams = {};
            data.appliedFilterFromUnbxd.forEach((filter)=>{
                var ref;
                const [key, value] = Object.entries(filter)[0];
                const unbxdKey = Object.keys(filterMapArr[0]).find((unbxdKey)=>filterMapArr[0][unbxdKey] === key);
                const facetValue = (ref = attributes[key]) === null || ref === void 0 ? void 0 : ref.options[value];
                if (unbxdKey && facetValue) {
                    validFilters.push({
                        facetName: unbxdKey,
                        facetValue
                    });
                    // Only keep valid ones for URL
                    validQueryParams[key] = value;
                } else {
                    console.warn("Removing invalid filter from URL:", {
                        key,
                        value
                    });
                }
            });
            // Sync URL with only valid filters
            const currentPath = router.pathname;
            router.replace({
                pathname: currentPath,
                query: validQueryParams
            }, undefined, {
                shallow: true
            });
            setSelectedFilterFromUnbxd(validFilters);
            // Build Unbxd URL
            const unbxdUrl = new URL("https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category");
            // Add base params
            unbxdUrl.searchParams.set("p", 'u_categoryPathId:"/tiles"');
            unbxdUrl.searchParams.append("facet.multiselect", "true");
            unbxdUrl.searchParams.append("spellcheck", "true");
            unbxdUrl.searchParams.append("pagetype", "boolean");
            unbxdUrl.searchParams.append("start", "0");
            unbxdUrl.searchParams.append("rows", "25");
            unbxdUrl.searchParams.append("version", "V2");
            unbxdUrl.searchParams.append("fallback", "true");
            unbxdUrl.searchParams.append("viewType", "GRID");
            unbxdUrl.searchParams.append("facet.version", "V2");
            validFilters.forEach((param)=>{
                let { facetName , facetValue  } = param;
                unbxdUrl.searchParams.append("filter", "".concat(facetName, ':"').concat(facetValue, '"'));
            });
            // Make API call
            (async ()=>{
                try {
                    const response = await axios/* default.get */.Z.get(unbxdUrl.toString(), {
                        headers: {
                            "unbxd-user-id": js_cookie/* default.get */.Z.get("unbxd.userId")
                        }
                    });
                    setUnbxdPdts(response.data.response.products);
                    setNoOfFilteredPdtFromUnbxd(response.data.response.numberOfProducts);
                    setPageSalesSize(response.data.response.products.length);
                } catch (error) {
                    console.error("Error fetching Unbxd products:", error);
                // swal("Something went wrong, please try again later.");
                }
            })();
        } else {
            // No filters applied
            const unbxdUrl1 = "https://search.unbxd.io/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-prod-orientbell53741713874410/category?p-id=categoryPathId%3A%22".concat(encodeURIComponent(router.asPath.split("?")[0]), "%22&facet.multiselect=true&spellcheck=true&pagetype=boolean&rows=25&start=0&version=V2&fallback=true&viewType=GRID&facet.version=V2");
            (async ()=>{
                try {
                    const response = await axios/* default.get */.Z.get(unbxdUrl1, {
                        headers: {
                            "unbxd-user-id": js_cookie/* default.get */.Z.get("unbxd.userId")
                        }
                    });
                    setUnbxdPdts(response.data.response.products);
                    setNoOfFilteredPdtFromUnbxd(response.data.response.numberOfProducts);
                    setPageSalesSize(response.data.response.products.length);
                } catch (error) {
                    console.error("Error fetching Unbxd products:", error);
                // swal("Something went wrong, please try again later.");
                }
            })();
        }
    }, [
        JSON.stringify(data.appliedFilterFromUnbxd)
    ]);
    const getImageName = (facetName)=>{
        switch(facetName){
            case "tileType_uFilter":
                return "/type.png";
            case "tileSize_uFilter":
                return "/size.png";
            case "tileDesign_uFilter":
                return "/design.png";
            default:
                return "/default-filter.png";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charset: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: dataSet.currentcategory.meta_title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: dataSet.currentcategory.meta_title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: dataSet.currentcategory.meta_description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: dataSet.currentcategory.meta_keywords
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "INDEX,FOLLOW"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "format-detection",
                        content: "telephone=no"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect dns-prefetch",
                        href: "https://connect.facebook.net",
                        crossorigin: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect dns-prefetch",
                        href: "https://www.googletagmanager.com",
                        crossorigin: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        "http-equiv": "Accept-CH",
                        content: "viewport-width, width, device-memory, dpr, downlink, ect"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "pinterest-rich-pin",
                        content: "false"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: dataSet.currentcategory.meta_description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: dataSet.currentcategory.meta_title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "".concat(config/* default.API_ENDPOINT */.Z.API_ENDPOINT, "/media/img/logo.png")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "Orientbell"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:creator",
                        content: "Orientbell"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/").concat(router.query.category)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: dataSet.currentcategory.meta_description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: dataSet.currentcategory.meta_title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "".concat(config/* default.API_ENDPOINT */.Z.API_ENDPOINT, "/media/img/logo.png")
                    }),
                    (dataSet === null || dataSet === void 0 ? void 0 : (ref5 = dataSet.currentcategory) === null || ref5 === void 0 ? void 0 : ref5.schema) && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: dataSet === null || dataSet === void 0 ? void 0 : (ref6 = dataSet.currentcategory) === null || ref6 === void 0 ? void 0 : ref6.schema.replace(/<script\s+type="application\/ld\+json">|<\/script>/g, "")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "".concat(config/* default.API_ENDPOINT */.Z.API_ENDPOINT, "/media/img/logo.png")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "text/javascript",
                        src: "https://cdn.roomvo.com/static/scripts/b2b/orientbell.js",
                        defer: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: webPageSchema()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: breadsCrumbSchema()
                    }),
                    data.videoSchema && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: data.videoSchema.replace(/<script\s+type="application\/ld\+json">|<\/script>/g, "")
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "page-wrapper category_listing_page",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "select-location-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "TO FIND PRICES IN YOUR CITY, ENTER YOUR PINCODE"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "select-wraper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        value: pincode,
                                        onChange: (e)=>handlePinCodeChangeInput(e)
                                    }),
                                    " ",
                                    pincode && (pincode === null || pincode === void 0 ? void 0 : pincode.length) == 6 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "btn-close close-btn",
                                        onClick: ()=>{
                                            setPinCode("");
                                            js_cookie/* default.remove */.Z.remove("pincode");
                                            localStorage.removeItem("pincode");
                                            router.reload();
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    (pincode === null || pincode === void 0 ? void 0 : pincode.length) == 0 || pincode == undefined || (pincode === null || pincode === void 0 ? void 0 : pincode.length) !== 6 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: " Invalid PinCode"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "category-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "category-view",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "filter-by-mobile flex-class",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "locaton-custom",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        class: "foot-icon-bx",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/Sort-By.svg",
                                                            alt: "sort"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                        className: "form-control",
                                                        id: "sel1",
                                                        value: sortValue,
                                                        onChange: (e)=>handleSortChange(e),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "",
                                                                children: "Sort By"
                                                            }),
                                                            dataSet.sort_fields.options.map((obj)=>{
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    value: obj.value,
                                                                    children: obj.label
                                                                }, obj.value);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "filter-col",
                                                onClick: ()=>setmobileFilterOpen(!mobileFilterOpen),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        class: "foot-icon-bx",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/filter.svg",
                                                            alt: "filter"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "sort-filter-col",
                                                        children: "Filter by"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: mobileFilterOpen ? "main-sidebar open-filter" : "main-sidebar",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "filter-heading-head",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "FILTERS"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "filter-close-bx",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/close-img.webp",
                                                            alt: "close",
                                                            onClick: ()=>setmobileFilterOpen(false)
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "filter-overlay-bx",
                                                onClick: ()=>setmobileFilterOpen(false)
                                            }),
                                            (ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : ProdBySalesDate.proCount) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "pro-filter-row",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: "add_cls",
                                                    children: filterTypeDataSet === null || filterTypeDataSet === void 0 ? void 0 : filterTypeDataSet.map((val, index)=>{
                                                        const imageName = "/".concat(val.toLowerCase(), ".png");
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            className: filteractive === index ? "filter-active-cls" : "filter-inactive-cat",
                                                            onClick: ()=>{
                                                                onFilterOnClickButton(val.toString());
                                                                setFilterActive(index);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "flt-type-img",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: imageName,
                                                                        alt: ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                                    children: [
                                                                        val == "Floor" ? "Wall/Floor" : val,
                                                                        " "
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "filters-by open-filter",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                        className: selectedCode == "colors" ? "color-row" : "",
                                                                        children: selectedFilterData === null || selectedFilterData === void 0 ? void 0 : selectedFilterData.map((obj, index)=>{
                                                                            if (router.query[selectedCode] == obj.key) {
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                    children: [
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                                            style: {
                                                                                                background: "#939393",
                                                                                                color: "white"
                                                                                            },
                                                                                            className: selectedCode == "colors" ? obj.value : "",
                                                                                            children: [
                                                                                                selectedCode == "colors" && /*#__PURE__*/ (0,jsx_runtime.jsx)("spna", {
                                                                                                    className: "color-option"
                                                                                                }),
                                                                                                obj.value
                                                                                            ]
                                                                                        }, index),
                                                                                        index == 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "popular-sparater"
                                                                                        })
                                                                                    ]
                                                                                });
                                                                            } else {
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                                            className: selectedCode == "colors" ? obj.value : "",
                                                                                            onClick: ()=>{
                                                                                                onFilterClick(obj.key, obj.value);
                                                                                            },
                                                                                            children: [
                                                                                                selectedCode == "colors" && /*#__PURE__*/ (0,jsx_runtime.jsx)("spna", {
                                                                                                    className: "color-option"
                                                                                                }),
                                                                                                obj.value
                                                                                            ]
                                                                                        }, index),
                                                                                        index == 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "popular-sparater"
                                                                                        })
                                                                                    ]
                                                                                });
                                                                            }
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }, index);
                                                    })
                                                })
                                            }) : Array.isArray(data === null || data === void 0 ? void 0 : (ref7 = data.facetsUnbxd) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.text) === null || ref8 === void 0 ? void 0 : ref8.list) && (data === null || data === void 0 ? void 0 : (ref9 = data.facetsUnbxd) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.text) === null || ref10 === void 0 ? void 0 : ref10.list.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "pro-filter-row",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: "add_cls tt",
                                                    children: (data === null || data === void 0 ? void 0 : (ref11 = data.facetsUnbxd) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.text) === null || ref12 === void 0 ? void 0 : ref12.list.length) > 1 && (data === null || data === void 0 ? void 0 : (ref13 = data.facetsUnbxd) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.text) === null || ref14 === void 0 ? void 0 : ref14.list.map((facet, facetIndex)=>{
                                                        const imageName = getImageName(facet === null || facet === void 0 ? void 0 : facet.filterField);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            className: filteractive === facetIndex ? "filter-active-cls" : "filter-inactive-cat",
                                                            onClick: ()=>{
                                                                setFilterActive(facetIndex);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "flt-type-img",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: imageName,
                                                                        alt: (facet === null || facet === void 0 ? void 0 : facet.displayName) || ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                    children: facet.displayName
                                                                }),
                                                                filteractive === facetIndex && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "filters-by open-filter",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                        children: facet.values.filter((_, index)=>index % 2 === 0).map((value, valueIndex)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                onClick: ()=>filterResultsWithFacets(facet.filterField, value),
                                                                                style: selectedFilterFromUnbxd.filter((i)=>i.facetValue === value).length > 0 ? {
                                                                                    background: "#939393",
                                                                                    color: "white"
                                                                                } : {},
                                                                                children: value
                                                                            }, valueIndex))
                                                                    })
                                                                })
                                                            ]
                                                        }, facetIndex);
                                                    }))
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "product-listing-wrap",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "bread-crumb-row",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            itemprop: "itemListElement",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL,
                                                                children: "Home"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            itemprop: "itemListElement",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "/tiles",
                                                                children: "Tiles"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                children: dataSet.currentcategory.name
                                            }),
                                            dataSet.currentcategory.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "category_accordion_data",
                                                dangerouslySetInnerHTML: {
                                                    __html: shortDiscription
                                                }
                                            }),
                                            (ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : ProdBySalesDate.proCount) >= 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "amshopby-filter cc",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    style: {
                                                        display: "unset"
                                                    },
                                                    children: [
                                                        selectedFilters.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "clear-all-btn",
                                                            onClick: ()=>removeAllFilters(),
                                                            children: "Clear All Filters X"
                                                        }),
                                                        data.data.products.appliedFilters.filter((cuu)=>{
                                                            return (cuu === null || cuu === void 0 ? void 0 : cuu.attribute_code) != "plocation";
                                                        }).map((obj, index)=>{
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                children: [
                                                                    obj.label,
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        onClick: ()=>handleRemove(obj),
                                                                        children: "X"
                                                                    })
                                                                ]
                                                            }, index);
                                                        }),
                                                        data.regionData && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            children: [
                                                                data.regionData.state,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    onClick: ()=>handleClick(),
                                                                    children: "X"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "amshopby-filter vv",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    children: [
                                                        selectedFilterFromUnbxd.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "clear-all-btn",
                                                            onClick: ()=>removeUnbxdFilters(),
                                                            children: "Clear All Filters X"
                                                        }),
                                                        selectedFilterFromUnbxd.map((filter, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                children: [
                                                                    filter.facetValue,
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        onClick: ()=>handleRemoveUnbxdFilter(filter),
                                                                        children: "X"
                                                                    })
                                                                ]
                                                            }, index))
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "category-sorting",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "tilecountis-bx",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        onClick: ()=>{
                                                                            handleLayOutclass("one");
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fa fa-th"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        onClick: ()=>{
                                                                            handleLayOutclass("two");
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fa fa-th-large"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        onClick: ()=>{
                                                                            handleLayOutclass("three");
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "fa fa-bars"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        (ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : ProdBySalesDate.proCount) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                "Items 1-",
                                                                ProdBySalesDate.data.length,
                                                                " of",
                                                                " ",
                                                                ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : ProdBySalesDate.proCount
                                                            ]
                                                        }) : !pincode && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "xxx",
                                                            children: (UnbxdPdts === null || UnbxdPdts === void 0 ? void 0 : UnbxdPdts.length) > 0 ? "Items 1-".concat(UnbxdPdts.length < data.UnbxdResponse.numberOfProducts ? UnbxdPdts.length : data.UnbxdResponse.numberOfProducts, " of ").concat(noOfFilteredPdtFromUnbxd || data.UnbxdResponse.numberOfProducts) : "Items 0 of 0"
                                                        })
                                                    ]
                                                })
                                            }),
                                            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: pageLayoutClass,
                                                    children: (ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : (ref15 = ProdBySalesDate.data) === null || ref15 === void 0 ? void 0 : ref15.length) > 0 ? ProdBySalesDate.data.map((product, index)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                (index == 3 || index == 27 || index == 51) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-listing-col",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: "/catagoryLeadImg.jpeg",
                                                                        onClick: ()=>setGetInTouch(true),
                                                                        className: "categoryBanner"
                                                                    })
                                                                }),
                                                                (index == 11 || index == 35 || index == 59) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-listing-col",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: "/OBL.jpg",
                                                                        onClick: ()=>setGetInTouch(true),
                                                                        alt: "image",
                                                                        className: "categoryBanner"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(productCard/* default */.Z, {
                                                                    isAmbience: isAmbience,
                                                                    product: product,
                                                                    category: dataSet.currentcategory.name,
                                                                    addProductToComapre: addProductToComapre
                                                                })
                                                            ]
                                                        });
                                                    }) : UnbxdPdts === null || UnbxdPdts === void 0 ? void 0 : UnbxdPdts.map((product, index)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                (index == 3 || index == 27 || index == 51) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-listing-col",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: "/catagoryLeadImg.jpeg",
                                                                        onClick: ()=>setGetInTouch(true),
                                                                        className: "categoryBanner"
                                                                    })
                                                                }),
                                                                (index == 11 || index == 35 || index == 59) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-listing-col",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: "/OBL.jpg",
                                                                        onClick: ()=>setGetInTouch(true),
                                                                        alt: "image",
                                                                        className: "categoryBanner"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UnbxdProductCard/* default */.Z, {
                                                                    isAmbience: isAmbience,
                                                                    product: product,
                                                                    category: dataSet.currentcategory.name,
                                                                    addProductToComapre: addProductToComapre
                                                                })
                                                            ]
                                                        });
                                                    })
                                                })
                                            }),
                                            loading2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "load-more-product",
                                                children: (ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : ProdBySalesDate.proCount) > 0 && (ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : ProdBySalesDate.proCount) != ProdBySalesDate.data.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    onClick: ()=>{
                                                        loadMoreSalesData();
                                                    },
                                                    children: [
                                                        "Load More From ",
                                                        (ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : ProdBySalesDate.proCount) - PageSalesSize
                                                    ]
                                                }) : (ProdBySalesDate === null || ProdBySalesDate === void 0 ? void 0 : ProdBySalesDate.length) === 0 && (UnbxdPdts === null || UnbxdPdts === void 0 ? void 0 : UnbxdPdts.length) > 0 && (UnbxdPdts === null || UnbxdPdts === void 0 ? void 0 : UnbxdPdts.length) < (noOfFilteredPdtFromUnbxd || data.UnbxdResponse.numberOfProducts) && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "bt",
                                                    onClick: ()=>{
                                                        pageSizeUnbxd += 25;
                                                        loadMoreSalesData2(); // Make sure this function updates noOfFilteredPdtFromUnbxd correctly
                                                        // After loading all products, update the total count to prevent incorrect numbers
                                                        if (UnbxdPdts.length === noOfFilteredPdtFromUnbxd) {
                                                            noOfFilteredPdtFromUnbxd = UnbxdPdts.length;
                                                        }
                                                    },
                                                    children: "Load More"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "category_accordion_data",
                                                dangerouslySetInnerHTML: {
                                                    __html: dataSet.currentcategory.dynamic_content.replace(/<p>\s*(&nbsp;)?\s*<\/p>/g, "")
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "tru_btn_new",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "btn btn-primary",
                                                    href: "/trialook",
                                                    children: "Trialook"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tile-related-blog-section",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container",
                                    children: (relatedBlogData === null || relatedBlogData === void 0 ? void 0 : relatedBlogData.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tile-related-blog",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "title",
                                                children: "Related Blogs"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "listing-Wrap",
                                                children: relatedBlogData === null || relatedBlogData === void 0 ? void 0 : relatedBlogData.map((obj, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "listing-col",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "listingImg",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: obj.permalink,
                                                                    rel: "nofollow",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: obj.image,
                                                                        loading: "lazy",
                                                                        alt: "Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "listing_blog_data",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "listingDate",
                                                                        children: obj.date
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "listingHead",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: obj.permalink,
                                                                            rel: "nofollow",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                dangerouslySetInnerHTML: {
                                                                                    __html: obj.title
                                                                                }
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "listingText",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                        children: [
                                                                            " ",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                dangerouslySetInnerHTML: {
                                                                                    __html: obj.content.slice(0, -11)
                                                                                }
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "listingButton",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: obj.permalink,
                                                                            rel: "nofollow",
                                                                            children: "Read More"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal show pincode-popup-bx",
                style: {
                    display: "block",
                    position: "initial"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                        show: modalIsOpen,
                        className: "pincode-popup-bx",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Dialog */.Z.Dialog, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                                        children: "Enter your Pincode for best prices"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            value: pincode,
                                            onChange: (e)=>handlePinCodeChange(e)
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Footer */.Z.Footer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "primary",
                                            onClick: ()=>handlePinSave(),
                                            children: "Submit"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "secondary",
                                            onClick: ()=>{
                                                setModalIsOpen(false);
                                                localStorage.setItem("pincodeSkip", true);
                                            },
                                            children: "Don't show again"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                        show: getInTouch,
                        className: "pincode-popup-bx expert_assistance_modal",
                        onHide: ()=>setGetInTouch(false),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Dialog */.Z.Dialog, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                                    closeButton: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                                        children: "Get Tile Expert Assistance"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                                        onSubmit: (e)=>{
                                            e.preventDefault();
                                            submitGetInTouch();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                                className: "mb-3",
                                                controlId: "formBasicEmail",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                        children: "Name"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                        type: "text",
                                                        placeholder: "Name*",
                                                        onChange: (e)=>{
                                                            setTouch({
                                                                ...touch,
                                                                name: e.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                                className: "mb-3",
                                                controlId: "formBasicPassword",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                        children: "Mobile"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                        type: "number",
                                                        placeholder: "Mobile Number*",
                                                        onChange: (e)=>{
                                                            setTouch({
                                                                ...touch,
                                                                number: e.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                                className: "mb-3",
                                                controlId: "formBasicPassword",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                        children: "Pincode"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                        type: "number",
                                                        placeholder: "Pincode",
                                                        onChange: (e)=>{
                                                            setTouch({
                                                                ...touch,
                                                                pincode: e.target.value
                                                            });
                                                        }
                                                    })
                                                ]
                                            }),
                                            touch.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "error text-danger",
                                                children: touch.error
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "primary",
                                                type: "submit",
                                                disabled: touch.loading,
                                                style: {
                                                    width: "100%"
                                                },
                                                children: touch.loading ? "Submitting" : "Submit"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var tiles = (Category);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7312,5518,4585,7615,6212,6737,7528,7851,3372,7349,166,9774,2888,179], function() { return __webpack_exec__(67636); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);